module.exports = __webpack_public_path__ + "img/money.954fffc7.svg";